import useSEO from "../hooks/useSEO";
import PageHero from "../components/PageHero";
import GallerySection from "../sections/GallerySection";
import InstagramFeed from "../sections/InstagramFeed";

export default function GalleryPage() {
  useSEO({
    title: "Gallery",
    description: "A visual journey through Ideal Entertainment's films, concerts and live experiences.",
  });
  return (
    <>
      <PageHero
        overline="Gallery"
        title="Moments from our world"
        subtitle="Behind the scenes, on stage and on set — explore the visuals."
        image="https://images.pexels.com/photos/13230484/pexels-photo-13230484.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=2000"
      />
      <GallerySection heading={false} />
      <InstagramFeed />
    </>
  );
}
